require("core-js");

// for old browsers to support element.classList for classes manipulation
require("./libs/class-list.min.js");

const sn = require("./src/components/scroll-notification.js");
sn.init();

require("./src/chat.js");
require("./css/app.styl");
